var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-2 d-12 d-lg-inline-block"},[(this.showLeftColumn())?_vm._t("stage-left"):_vm._e()],2),_c('div',{class:this.showLeftColumn()
            ? 'col-12 col-lg-10'
            : 'col-12 col-lg-10 offset-lg-1'},[_vm._t("stage-main")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }